// @flow

/**
 * Akcje przenoszenia draftow do innych kategorii oraz dodawania nowych
 */

import $ from 'jquery';
import axios from 'axios';
import { loader } from './loader';
import { makeRequest } from './request';
import { datatablesArr } from './../components/datatables';
import { refreshTable } from './../components/datatables-helpers';


function clickAction(options, tablename) {
    if (options) {
        makeRequest(options, () => {
            refreshTable(datatablesArr[tablename]);
        });
    } else {
        throw new Error('No data-ajax attribute !');
    }
}

function init() {
    // add new draft to folder
    $(document).on('click', '.js-addnew', function (e) {
        const options = $(this).data('ajax');
        const tablename = $(this).data('table-to-refresh');

        clickAction(options, tablename);
        e.preventDefault();
    });

    // move draft to another category
    $(document).on('click', '.js-movetocategory', function (e) {
        const options = $(this).data('ajax');
        const tablename = $(this).data('table-to-refresh');

        clickAction(options, tablename);
        e.preventDefault();
    });
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/draft-popups.js